/* istanbul ignore file */
import React from 'react';
import ProtectedRoute from 'infrastructure/routing/ProtectedRoute';

const ProtectedRouter = ({ basePath, children }: { basePath?: string | string[]; children: React.ReactNode }) => (
  <ProtectedRoute path={basePath}>{children}</ProtectedRoute>
);

export default ProtectedRouter;
